$(document).ready(function () {
    $('.dropdown-content').on('mouseenter', function () {
        $(this).prev('.button-dropdown').addClass('hovered')
    }).on('mouseleave', function () {
        $(this).prev('.button-dropdown').removeClass('hovered');
    })
})